import { companyMock } from '@domain/company/company.mocks';
import { settingsMock } from '@domain/settings/settings.mock';
import { userConfigMock } from '@domain/user-config/user-config.mock';
import getObjectSelected from './getObjectSelected.mock';

const initialStateMock = (isAccount = true, isFacebook = false) => ({
    ...companyMock,
    ...settingsMock,
    ...userConfigMock,
    team: {
        data: {},
    },
    loggedUser: {
        data: {
            full_name: 'LOGGED_USER',
            id: '20',
            user: '25',
            currency: 'BRL',
            phone: '99999999',
            user_img_path: 'IMG_PATH',
            username: 'USER_NAME',
            email: 'LOGGED_USER@EMAIL.COM',
            default_language: 'pt',
            has_integrations: true,
            is_agency_mode: true,
            timer: {},
            loadingHasIntegration: false,
        },
    },
    data: {
        ...getObjectSelected({ isAccount, isFacebook }),
    },
});

export {
    initialStateMock,
};
